import { ObjectType } from '../../Types/base';
import { EventActiveModuleKey } from '../../Types/event';
import { get, post } from '../common';

const eventActiveModulesEndpoint = 'api/event/activemodules';

export type ModuleOptionKind = 'OBJECT_TYPE' | 'BUILT_IN_TAB';

export type ModuleOption = {
	Key: EventActiveModuleKey | string;
	Kind: ModuleOptionKind | string;
	ObjectType?: ObjectType | null;
	Name: string;
	Description?: string;
	IsEnabled: boolean;
};

export type SaveActiveModulesRequest = {
	eventId: number;
	activeModules: string[];
};

// Get available modules filtered by portal settings
export async function getAvailableModulesForEvent(): Promise<ModuleOption[]> {
	const endpoint = `${eventActiveModulesEndpoint}/GetAvailableModules`;
	const result = await get<ModuleOption[]>(endpoint);
	return result || [];
}

// Get currently active modules for an event
export async function getEventActiveModules(eventId: number): Promise<string[]> {
	const endpoint = `${eventActiveModulesEndpoint}/GetEventActiveModules?eventId=${eventId}`;
	const result = await get<string[]>(endpoint);
	return result || [];
}

// Update active modules for an event
export async function updateEventActiveModules(request: SaveActiveModulesRequest): Promise<void> {
	const endpoint = `${eventActiveModulesEndpoint}/UpdateEventActiveModules`;
	await post(endpoint, request);
}